(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.hero__media').forEach((media) => {
    if (media.tagName !== 'VIDEO') return;
    const resumePlayback = () => {
      const playPromise = media.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {
          setTimeout(() => media.play().catch(() => {}), 1000);
        });
      }
    };
    media.addEventListener('ended', resumePlayback);
    media.addEventListener('pause', resumePlayback);
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible' && media.paused) {
        resumePlayback();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
